import { PlusOutlined, SearchOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useMediaQuery } from 'react-responsive'
import { useLocation } from 'react-router-dom'
import styled from 'styled-components'
import { translate } from '../languages'
import { ApiMethodEnum, UserTypeEnum } from '../models'
import { RootState } from '../stores'
import { setShowManageModal, setShowSearchDrawer } from '../stores/actions'

const StyledHeader = styled.div`
  width: 100%;
  height: 7.5%;
  margin-top: 5px;
`

const StyledLabel = styled.span`
  margin: 20px;
  float: left;
  margin-left: 0;
  font-weight: bold;
  font-size: 1rem;
`

type PageTitleComponentProps = {
  onCreateButtonClick?: () => void
  hasSearchDrawer?: boolean
  customButtons?: React.ReactElement
}

export const PageTitleComponent: React.FC<PageTitleComponentProps> = ({
  onCreateButtonClick,
  hasSearchDrawer,
  customButtons,
}) => {
  const dispatch = useDispatch()
  const location = useLocation()
  const { language } = useSelector((state: RootState) => state.language)
  const { profile } = useSelector((state: RootState) => state.auth)

  const { apis } = useSelector((state: RootState) => state.api)
  const isDesktopScreen = useMediaQuery({ minWidth: '1300px' })

  return (
    <StyledHeader>
      {isDesktopScreen && (
        <StyledLabel>
          {`${translate('common.manage', language)} ${translate(
            `api.name.${location.pathname.replace(/\//, '')}`,
            language
          )}`}
        </StyledLabel>
      )}
      {onCreateButtonClick &&
        (profile?.userType.type === UserTypeEnum.ADMIN ||
          apis.filter(
            (item) =>
              item.method === ApiMethodEnum.POST &&
              item.path === location.pathname
          ).length > 0) && (
          <Button
            onClick={() => {
              onCreateButtonClick()
              dispatch(setShowManageModal(true))
            }}
            type="primary"
            style={{ margin: '20px 0', float: 'right' }}
            icon={<PlusOutlined />}
            size={!isDesktopScreen ? 'small' : 'middle'}
          >
            {`${translate('common.add', language)} ${translate(
              `api.name.${location.pathname.replace(/\//, '')}`,
              language
            )}`}
          </Button>
        )}
      {customButtons}
      {hasSearchDrawer && !isDesktopScreen && (
        <Button
          onClick={() => dispatch(setShowSearchDrawer(true))}
          type="primary"
          style={{ margin: '20px 10px 0', float: 'right' }}
          size={!isDesktopScreen ? 'small' : 'middle'}
          icon={<SearchOutlined />}
        >
          {translate('common.search.detail', language)}
        </Button>
      )}
    </StyledHeader>
  )
}
